export const mobileDeliveryListStyles = {
  width: "100%",
  "& .RaDatagrid-table": {
    tableLayout: "fixed",
    width: "100%",
  },
  "& .RaDatagrid-headerCell, & .RaDatagrid-rowCell": {
    minWidth: 0,
    overflowWrap: "anywhere",
    px: 1,
    py: 1,
    verticalAlign: "top",
    whiteSpace: "pre-line",
  },
  "& .RaDatagrid-expandHeader, & .RaDatagrid-expandIconCell": {
    minWidth: 0,
    padding: 0,
    width: "1.75rem",
  },
  "& .RaDatagrid-expandIcon": {
    padding: "0.25rem",
    pointerEvents: "none",
  },
  "& .delivery-id": {
    minWidth: 0,
    width: "3.5rem",
  },
  "& .delivery-handover-at": {
    minWidth: 0,
    width: "6rem",
    overflowWrap: "normal",
  },
};
